// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var Check = React.forwardRef(function Check(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Check" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 6.04008L9.80083 20L3 14.22L4.94265 11.7536L9.39042 15.5338L18.6433 4L21 6.04008Z", fill: "currentColor" }))));
});
Check.displayName = 'Check';
export default Check;
//# sourceMappingURL=Check.js.map